import { ChangeEvent, useRef } from 'react';
import { FileDropItem, useDrop } from '@react-aria/dnd';



interface DroppableFileInputProps {
	uploadFile: (file: FormData) => void,
}


export const DroppableFileInput = (props: DroppableFileInputProps) => {
	const { uploadFile } = props;


	const ref = useRef<HTMLLabelElement>(null);
	
	const { dropProps, isDropTarget } = useDrop({
		ref,
		async onDrop(e) {
			let item = e.items.find((item) => item.kind === 'file' && (
				item.type === 'text/csv' ||
				item.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
				item.type === 'application/vnd.ms-excel')) as FileDropItem;
			if (item) {
				let formData = new FormData();
				let file = await item.getFile();
				formData.append('file', file);
				uploadFile(formData);
			}
		}
	});

	return (
		<label
			{...dropProps}
			role="button"
			tabIndex={0}
			ref={ref}
			htmlFor='fileSelect'
			className={`droppable-file-input-drop droppable ${isDropTarget ? 'target' : ''}`}
			id='dropcontainer'>

			<span className='drop-title'>Přetáhněte soubory sem</span>
				nebo
			<input
				className='upload-input'
				id='fileSelect'
				type='file'
				accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' 
				onChange={async(event: ChangeEvent<HTMLInputElement>) => {
					if (!event || !event.target || !event.target.files)
						return;
					
					let file = event.target.files[0];
					if (!file)
						return;
					if (file.type !== 'text/csv'
						&& file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
						&& file.type !== 'application/vnd.ms-excel')
						return;
					
					let formData = new FormData();
					formData.append('file', file);
					uploadFile(formData);
				}}/>
		</label>
	)
}

export default DroppableFileInput;